import { useState, useEffect } from "react"
import get from "lodash/get"
import { authRequest } from "src/engine/modules/authRequest"
import { showToast } from "@infotech/uikit-toasts"

export const useEventStatus = ({ id }) => {
  const [formData, changeFormData] = useState({
    data: {
      code: null,
      color: null,
      eventTypeId: null,
      id: null,
      initial: false,
      name: null,
      statusId: null,
      restrictions: {
        delete: false,
        description: false,
        endDateTime: false,
        name: false,
        plan: false,
        eventType: false,
        resources: false,
        restrictedResourceTypes: [],
        startDateTime: false,
      },
    },
    pending: true,
  })
  useEffect(() => {
    if (id) {
      authRequest({
        url: `/event-status/${id}`,
        method: `get`,
      })
        .then(response => {
          changeFormData({ data: response.data, pending: false })
        })
        .catch(error => {
          if (error) {
            showToast({
              type: `error`,
              message: get(error, `response.data.exception`) || `Unknown error`,
              hideIn: 5,
            })
          }
        })
    }
  }, [id])
  return { formData, changeFormData }
}

export const createEventStatus = ({
  eventTypeId,
  id,
  toggleForm,
  refreshList,
}) => {
  authRequest({
    url: `/event-status`,
    method: `post`,
    data: { statusId: id, eventTypeId, initial: false },
  })
    .then(response => {
      showToast({
        type: `success`,
        message: `Статус "${get(response, `data.name`)}" добавлен`,
        hideIn: 5,
      })
      toggleForm({ show: true, id: get(response, `data.id`) })
      refreshList()
    })
    .catch(error => {
      if (error) {
        showToast({
          type: `error`,
          message: get(error, `response.data.exception`) || `Unknown error`,
          hideIn: 5,
        })
      }
    })
}

export const updateEventStatus = ({
  data,
  id,
  refreshList,
  changeData,
  setChangeCount,
  changeFormData,
  allFormData,
}) => {
  authRequest({
    url: `/event-status/${id}`,
    method: `put`,
    data,
  })
    .then(response => {
      showToast({
        type: `success`,
        message: `Статус "${get(response, `data.name`)}" изменен`,
        hideIn: 5,
      })
      refreshList()
    })
    .catch(error => {
      const changeDataAfterError = !changeData.restrictions
        ? {
            ...allFormData,
            data: {
              ...allFormData.data,
              [changeData.changeField]: changeData.oldValue,
            },
          }
        : {
            ...allFormData,
            data: {
              ...allFormData.data,
              restrictions: {
                ...allFormData.data.restrictions,
                [changeData.changeField]: changeData.oldValue,
              },
            },
          }
      setChangeCount(null)
      changeFormData(changeDataAfterError)
      if (error) {
        showToast({
          type: `error`,
          message: get(error, `response.data.exception`) || `Unknown error`,
          hideIn: 5,
        })
      }
    })
}

export const removeEventStatus = ({ id, name, refreshList }) => {
  authRequest({
    url: `/event-status/${id}`,
    method: `delete`,
  })
    .then(() => {
      showToast({
        type: `error`,
        message: `Статус "${name}" удален.`,
        hideIn: 5,
      })
      refreshList()
    })
    .catch(error =>
      showToast({
        type: `error`,
        message: error.data.exception || `Unknown error`,
        hideIn: 5,
      }),
    )
}
